import apiCompetition from '@/api/competition'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 1,
  lastPage: null,
}

export const mutationTypes = {
  getCompetitionsCalendarStart:
    '[competition calendar plan] Get competitions plan start',
  getCompetitionsCalendarSuccess:
    '[competition calendar plan] Get competitions plan success',
  getCompetitionsCalendarFailure:
    '[competition calendar plan] Get competitions plan failure',
}

export const actionTypes = {
  getCompetitionsCalendar: '[competition calendar plan] Get competition plan',
}

const mutations = {
  [mutationTypes.getCompetitionsCalendarStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getCompetitionsCalendarSuccess](state, payload) {
    state.data = payload.data
    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsCalendarFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getCompetitionsCalendar](context, {params}) {
    context.commit(mutationTypes.getCompetitionsCalendarStart)
    return new Promise((resolve) => {
      apiCompetition
        .getCompetitionCalendarPlan(params)
        .then((response) => {
          context.commit(
            mutationTypes.getCompetitionsCalendarSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getCompetitionsCalendarFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
